/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Table_Icon_HeaderInputs */

const en_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon`)
};

const fr_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icone`)
};

const de_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Symbol`)
};

const it_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icona`)
};

const ru_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Икона`)
};

const es_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icono`)
};

const zh_cn2_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图标`)
};

const ja_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイコン`)
};

const hi_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइकन`)
};

const pt_pt2_speakers_table_icon_header = /** @type {(inputs: Speakers_Table_Icon_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ícone`)
};

/**
* | output |
* | --- |
* | "Icon" |
*
* @param {Speakers_Table_Icon_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_table_icon_header = /** @type {((inputs?: Speakers_Table_Icon_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Table_Icon_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_table_icon_header(inputs)
	if (locale === "de") return de_speakers_table_icon_header(inputs)
	if (locale === "it") return it_speakers_table_icon_header(inputs)
	if (locale === "ru") return ru_speakers_table_icon_header(inputs)
	if (locale === "es") return es_speakers_table_icon_header(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_table_icon_header(inputs)
	if (locale === "ja") return ja_speakers_table_icon_header(inputs)
	if (locale === "hi") return hi_speakers_table_icon_header(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_table_icon_header(inputs)
	return en_speakers_table_icon_header(inputs)
});